import { BillingDetailModel } from "../customer/billing-detail.model";
import { JobSiteDetailModel } from "../customer/job-site-detail-model";
import { SaItemModel } from "../price-book/sa-item.model";
import { WorkOrderModel } from "../work-order/work-order.model";
import { AgreementRequestModel } from "./request.model";

export class AgreementResponseModel extends AgreementRequestModel {
    AgreementStatus: string;
    Customer: BillingDetailModel;
    JobSite: JobSiteDetailModel;
    ServiceAgreementItem: SaItemModel;
    ModifyDate: string;
    ServiceAgreementNumber: string;
    OriginatingWorkticket: WorkOrderModel;
    ServiceAgreementEquipments = [];
    ItemDiscount: number;
    OriginatedStandardPrice: number;

    constructor() {
        super();
        this.AgreementStatus = "";
        this.Customer = new BillingDetailModel();
        this.JobSite = new JobSiteDetailModel();
        this.ServiceAgreementItem = new SaItemModel();
        this.ModifyDate = "";
        this.ServiceAgreementNumber = "";
        this.OriginatingWorkticket = new WorkOrderModel();
        this.ItemDiscount = 0;
        this.OriginatedStandardPrice = 0;
    }
}